import { z } from 'zod';
// Owner-only batch update of per-photo ratings under a single root.
// keyGen is the generation the client believes the photo is on; the backend
// rejects (409) any item where the stored keyGen has moved on, so a rating
// write that races a rotation never lands on a stale ciphertext key.
// encryptedRating absent → clears the rating (REMOVE the attribute).
export const RatePhotosBatchRequest = z.object({
    rootAlbumId: z.string().min(1),
    items: z
        .array(z.object({
        albumId: z.string().min(1),
        photoId: z.string().min(1),
        keyGen: z.number().int().positive(),
        encryptedRating: z.string().min(1).optional(),
    }))
        .min(1)
        .max(200),
});
export const RatePhotosBatchResponse = z.object({
    updated: z.array(z.string()),
    // Photo IDs whose stored keyGen no longer matches the request — the client
    // should re-fetch the album and retry with the fresh generation.
    conflicts: z.array(z.string()),
});
//# sourceMappingURL=rating.js.map